import React from 'react';
import styled from 'styled-components';
import { device } from '../utils/device';

const StyledButton = styled.button`
  padding: 10px 36px;
  border: none;
  border-radius: 8px;
  min-height:60px;
  background:#F68C3E;
  color: ${props => props.theme.colors?.white || 'white'};
  font-size: 20px;
  letter-spacing: 0.02em;
  font-family: "Nunito Sans", sans-serif;
  font-weight: bold;
  cursor: pointer;
  z-index: 20;
  transition: all .1s;

  @media ${device.tablet} {
    padding: 10px 25px;
  }

  &:hover {
      transform: scale(1.03);
    }
`;

const ButtonSmall = styled(StyledButton)`
  &&& {
    padding: 10px 35px;
    font-size: 16px;
    font-weight: bold;
  }

  @media only screen and (min-width: 992px) and (max-width: 1024px) {
    padding:10px 15px !important;
    min-height:45px;
  }
  @media only screen and (min-width: 1025px) and (max-width: 1199px) {
    margin:0 !important;
    padding: 11px 25px !important;
    min-height:45px;
  }
  @media only screen and (min-width: 1200px) and (max-width: 1478px) {
    margin:0 !important;
    padding: 11px 20px !important;
    min-height:45px;
  }

  @media (min-width:1479px){
    min-height:45px;
  }


`;

const ButtonWhite = styled(StyledButton)`
  font-weight: 400;
  background: ${props => props.theme.colors?.white || 'white'};
  color: ${props => props.theme.colors?.darkOrange || 'orange'};
  border: 1px solid ${props => props.theme.colors?.darkOrange || 'orange'};

  &:hover {
    background-color: ${props => props.theme.colors?.darkOrange || 'orange'};
    color: ${props => props.theme.colors?.white || 'white'};
  }
`;

const ButtonBlue = styled(StyledButton)`
  &&& {
    border-radius: 5px;
    font-weight: bold;
    font-size:16px;
    letter-spacing: 0.02em;
    background: #004385 !important;
    min-height:40px;
    color: ${props => props.theme.colors?.white || 'white'};

    &:hover {
      background: ${props => props.theme.colors?.darkBlue || 'blue'};
    }
  }
`;

const ButtonGray = styled(StyledButton)`
  font-weight: 400;
  background: ${props => props.theme.colors?.mediumGray || 'gray'};
  color: ${props => props.theme.colors?.white || 'white'};

  &:hover {
      background: ${props => props.theme.colors?.darkGray || 'gray'};
    }
`;

const ButtonExpand = styled(StyledButton)`
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const ButtonResponsive = styled(StyledButton)`
  &&& {
    font-weight: bold;
    padding: 12px 24px;
    font-size: 16px;
  }

  @media (max-width: 1240px) {
    padding: 5px 15px;
    font-size: 16px;
  }
  @media (max-width: 1100px) {
    padding: 5px 12px;
    font-size: 14px;
  }
`;

function Button(props) {
  return (
    <StyledButton {...props}>{props.children}</StyledButton>
  );
}

Button.Small = ButtonSmall;
Button.White = ButtonWhite;
Button.Blue = ButtonBlue;
Button.Gray = ButtonGray;
Button.Expand = ButtonExpand;
Button.Responsive = ButtonResponsive;

export default Button;